let activeController = null;
let activeAvailabilityObserver = null;
const initLiftKitStickyAtc = (root = document) => {
  activeController == null ? void 0 : activeController.abort();
  activeAvailabilityObserver == null ? void 0 : activeAvailabilityObserver.disconnect();
  activeController = new AbortController();
  const { signal } = activeController;
  const bar = root.querySelector("[data-lk-sticky]");
  if (bar && bar.dataset.lkStickyReady !== "true") {
    bar.dataset.lkStickyReady = "true";
    const form = bar.querySelector("[data-lk-sticky-form]");
    const btn = bar.querySelector("[data-lk-sticky-btn]");
    const isCustomKitMode = bar.dataset.customKitMode === "true";
    const purchaseRoot = isCustomKitMode ? bar.closest("section") || bar : bar;
    const customKitAtc = purchaseRoot == null ? void 0 : purchaseRoot.querySelector("[data-custom-kit-atc]");
    const purchaseButtons = [btn, customKitAtc].filter(Boolean);
    let isAddingCustomKit = false;
    const cart = document.querySelector("cart-drawer");
    const currentPriceEls = purchaseRoot.querySelectorAll("[data-lk-current-price]");
    const comparePriceEls = purchaseRoot.querySelectorAll("[data-lk-compare-price]");
    const savingsPriceEls = purchaseRoot.querySelectorAll("[data-lk-savings-price]");
    const availabilityEls = purchaseRoot.querySelectorAll("[data-lk-availability]");
    const availabilityTextEls = purchaseRoot.querySelectorAll("[data-lk-availability-text]");
    const productImageEl = bar.querySelector("[data-lk-product-image]");
    const variantImagesEl = bar.querySelector("[data-lk-variant-images]");
    const inlineAtc = document.querySelector("[data-lk-inline-atc]");
    const variantIdInput = form == null ? void 0 : form.querySelector('[name="id"]');
    const quantityInput = form == null ? void 0 : form.querySelector('[name="quantity"]');
    let activeMainPriceCents = Number(bar.dataset.lkBasePrice) || 0;
    let activeMainComparePriceCents = Number(bar.dataset.lkBaseComparePrice) || 0;
    let activeMainAvailable = !(btn == null ? void 0 : btn.disabled);
    let variantImageMap = {};
    if (variantImagesEl == null ? void 0 : variantImagesEl.textContent) {
      try {
        variantImageMap = JSON.parse(variantImagesEl.textContent);
      } catch (error) {
        console.warn("Failed to parse sticky variant image map.", error);
      }
    }
    const formatMoney = (cents) => {
      var _a, _b, _c, _d;
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, window.shopCurrencyFormat || "${{amount}}");
      }
      const amount = (Number(cents) || 0) / 100;
      const currency = ((_b = (_a = window.Shopify) == null ? void 0 : _a.currency) == null ? void 0 : _b.active) || ((_d = (_c = window.Shopify) == null ? void 0 : _c.currency) == null ? void 0 : _d.currency) || window.currency || "USD";
      try {
        return new Intl.NumberFormat(void 0, {
          style: "currency",
          currency
        }).format(amount);
      } catch {
        return amount.toFixed(2);
      }
    };
    const setText = (elements, value) => {
      elements.forEach((el) => {
        el.textContent = value;
      });
    };
    const setCurrentPriceText = (elements, value) => {
      elements.forEach((el) => {
        const prefix = (el.dataset.lkPricePrefix || "").trim();
        el.textContent = prefix ? `${prefix} ${value}` : value;
      });
    };
    const setVisibility = (elements, hidden) => {
      elements.forEach((el) => {
        el.classList.toggle("hidden", hidden);
      });
    };
    const updateProductImage = (variantId) => {
      if (!productImageEl) return;
      const imageData = (variantId != null ? variantImageMap == null ? void 0 : variantImageMap[String(variantId)] : null) || (variantImageMap == null ? void 0 : variantImageMap.default);
      if (!(imageData == null ? void 0 : imageData.src)) return;
      productImageEl.src = imageData.src;
      productImageEl.setAttribute("src", imageData.src);
      if (imageData.alt) {
        productImageEl.alt = imageData.alt;
        productImageEl.setAttribute("alt", imageData.alt);
      }
    };
    const isOutOfStockText = (text = "") => /out of stock|sold out|unavailable|backorder|back-ordered|call for eta/i.test(text);
    const updateAvailabilityTone = (isOutOfStock) => {
      availabilityEls.forEach((el) => {
        el.classList.toggle("text-[#056F3D]", !isOutOfStock);
        el.classList.toggle("text-[#056f3d]", !isOutOfStock);
        el.classList.toggle("text-[#9a0000]", isOutOfStock);
      });
    };
    const setAvailabilityText = (text = "") => {
      const nextText = text.trim();
      const hasText = nextText.length > 0;
      availabilityEls.forEach((el) => {
        el.classList.toggle("invisible", !hasText);
      });
      availabilityTextEls.forEach((el) => {
        el.textContent = nextText;
      });
      if (hasText) {
        updateAvailabilityTone(isOutOfStockText(nextText));
      }
    };
    const getMainProductForm = () => document.querySelector(
      'product-form form[data-type="add-to-cart-form"], form[data-type="add-to-cart-form"]'
    );
    const getMainAtcButton = () => {
      var _a;
      return (_a = getMainProductForm()) == null ? void 0 : _a.querySelector('[type="submit"][name="add"], [data-add-to-cart]');
    };
    const syncLiftKitInstallationQuote = async () => {
      const quoteInput = document.querySelector("lift-kit-widget .lift-kit-attr");
      if (!quoteInput) return;
      const response = await fetch(window.routes.cart_update_url || "/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          attributes: {
            _lift_kit_installation_quote: quoteInput.value === "True" ? "True" : ""
          }
        })
      });
      if (!response.ok) {
        throw new Error(`Could not save installation quote selection (${response.status}).`);
      }
    };
    const getMainQuantity = () => {
      const mainForm = getMainProductForm();
      const mainQuantityInput = mainForm == null ? void 0 : mainForm.querySelector('[name="quantity"]');
      const mainQuantity = parseInt(mainQuantityInput == null ? void 0 : mainQuantityInput.value, 10);
      if (mainQuantity > 0) return mainQuantity;
      const stickyQuantity = parseInt(quantityInput == null ? void 0 : quantityInput.value, 10);
      return stickyQuantity > 0 ? stickyQuantity : 1;
    };
    const getActiveVariantId = () => {
      var _a, _b, _c, _d, _e;
      const fromVariantForm = Number(
        (_b = (_a = document.querySelector("variant-form-custom")) == null ? void 0 : _a.currentVariant) == null ? void 0 : _b.id
      );
      if (Number.isFinite(fromVariantForm) && fromVariantForm > 0) return fromVariantForm;
      const fromMainForm = Number((_d = (_c = getMainProductForm()) == null ? void 0 : _c.querySelector('input[name="id"]')) == null ? void 0 : _d.value);
      if (Number.isFinite(fromMainForm) && fromMainForm > 0) return fromMainForm;
      const fromStickyForm = Number(variantIdInput == null ? void 0 : variantIdInput.value);
      if (Number.isFinite(fromStickyForm) && fromStickyForm > 0) return fromStickyForm;
      const fromLastEvent = Number((_e = window.__lastVariantChange) == null ? void 0 : _e.id);
      if (Number.isFinite(fromLastEvent) && fromLastEvent > 0) return fromLastEvent;
      return null;
    };
    const getSelectedTireItems = (mainQuantity = 1) => {
      const source = window.TireWidgetAddon;
      if (!source || typeof source.getSelectedCartItems !== "function") return [];
      const items = source.getSelectedCartItems(mainQuantity);
      if (!Array.isArray(items) || !items.length) return [];
      return items.filter((item) => Number(item == null ? void 0 : item.id) > 0).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || 1),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    };
    const getSelectedFrontShockAssemblyItems = (mainQuantity = 1) => {
      const source = window.MudifyFrontShockAssembly;
      if (!source || typeof source.getSelectedItems !== "function") return [];
      const items = source.getSelectedItems({ quantity: mainQuantity });
      if (!Array.isArray(items) || !items.length) return [];
      return items.filter((item) => Number(item == null ? void 0 : item.id) > 0).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || 1),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    };
    const getCustomKitConfigurator = () => {
      var _a;
      return ((_a = bar.closest("section")) == null ? void 0 : _a.querySelector("custom-kit-configurator")) || null;
    };
    const getSelectedCustomKitItems = (mainQuantity = 1) => {
      const configurator = getCustomKitConfigurator();
      if (!configurator || typeof configurator.getCartItems !== "function") return [];
      const items = configurator.getCartItems(mainQuantity);
      if (!Array.isArray(items) || !items.length) return [];
      return items.filter((item) => Number(item == null ? void 0 : item.id) > 0).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || 1),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    };
    const getCustomKitPartsTotalCents = () => {
      const configurator = getCustomKitConfigurator();
      if (!configurator || typeof configurator.getSelectedTotalCents !== "function") return 0;
      return Math.max(0, Number(configurator.getSelectedTotalCents()) || 0);
    };
    const hasCustomKitSelection = () => {
      const configurator = getCustomKitConfigurator();
      if (!configurator || typeof configurator.getSelectedVariantIds !== "function") return false;
      return Object.values(configurator.getSelectedVariantIds()).some((id) => Number(id) > 0);
    };
    const getSelectedUcaItems = (mainQuantity = 1) => {
      const source = window.UCAAddons;
      if (!source || typeof source.getSelectedCartItems !== "function") return [];
      const items = source.getSelectedCartItems();
      if (!Array.isArray(items) || !items.length) return [];
      const quantity = Math.max(1, Number(mainQuantity) || 1);
      return items.filter((item) => Number(item == null ? void 0 : item.id) > 0).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, (Number(item.quantity) || 1) * quantity),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    };
    const getSelectedAddonItems = (mainQuantity = 1, mainVariantId = 0) => {
      if (!window.MudifyMoreAddons || typeof window.MudifyMoreAddons.getSelectedItems !== "function") {
        return [];
      }
      const items = window.MudifyMoreAddons.getSelectedItems({ quantity: mainQuantity });
      if (!Array.isArray(items) || !items.length) return [];
      return items.filter((item) => {
        const addonId = Number(item == null ? void 0 : item.id);
        return addonId > 0 && addonId !== mainVariantId;
      }).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || mainQuantity),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    };
    const buildAddonSignature = ({
      ucaItems = [],
      tireItems = [],
      addonItems = [],
      frontShockAssemblyItems = [],
      customKitItems = []
    } = {}) => {
      const serialize = (items, extra = null) => items.map((item) => {
        const itemId = Number(item == null ? void 0 : item.id) || 0;
        const itemQuantity = Math.max(1, Number(item == null ? void 0 : item.quantity) || 1);
        const suffix = typeof extra === "function" ? extra(item) : "";
        return `${itemId}x${itemQuantity}${suffix ? `:${suffix}` : ""}`;
      }).filter(Boolean).sort();
      const uca = serialize(ucaItems);
      const tires = serialize(
        tireItems,
        (item) => {
          var _a, _b;
          return String(((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._tire_choice_id) || ((_b = item == null ? void 0 : item.properties) == null ? void 0 : _b._tire_variant_sku) || "").trim();
        }
      );
      const addons = serialize(addonItems);
      const frontShockAssembly = serialize(
        frontShockAssemblyItems,
        (item) => {
          var _a;
          return String(((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a["_FSA Group"]) || "").trim();
        }
      );
      const customKit = serialize(
        customKitItems,
        (item) => {
          var _a;
          return String(((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a["_Custom Kit Component"]) || "").trim();
        }
      );
      const parts = [];
      if (uca.length) parts.push(`uca=${uca.join(",")}`);
      if (tires.length) parts.push(`tire=${tires.join(",")}`);
      if (addons.length) parts.push(`addons=${addons.join(",")}`);
      if (frontShockAssembly.length) parts.push(`fsa=${frontShockAssembly.join(",")}`);
      if (customKit.length) parts.push(`custom-kit=${customKit.join(",")}`);
      return parts.join("|");
    };
    const buildMainCartItem = (id, quantity) => ({
      id: Number(id),
      quantity: Math.max(1, Number(quantity) || 1)
    });
    const applyAddonSignatureToMainItem = (mainItem, context = {}) => {
      if (!mainItem) return null;
      const signature = buildAddonSignature(context);
      if (!signature) return mainItem;
      mainItem.properties = {
        ...mainItem.properties || {},
        "_Addon Signature": signature
      };
      return mainItem;
    };
    const addMainAndExtraItems = async (mainItem, extraItems = []) => {
      const items = [mainItem, ...extraItems].filter((item) => Number(item == null ? void 0 : item.id) > 0);
      if (!items.length) return null;
      const body = { items };
      if (cart && typeof cart.getSectionsToRender === "function") {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(body)
      });
      let json = null;
      let rawText = "";
      try {
        json = await response.clone().json();
      } catch (_) {
        try {
          rawText = await response.text();
          json = rawText ? JSON.parse(rawText) : null;
        } catch (__) {
          json = null;
        }
      }
      if (json == null) {
        throw new Error(`Unexpected cart response (${response.status}).`);
      }
      if (!response.ok || json && json.status) {
        throw new Error((json == null ? void 0 : json.description) || (json == null ? void 0 : json.message) || `Cart add failed (${response.status})`);
      }
      return json;
    };
    const syncCustomKitStickyState = () => {
      var _a, _b, _c;
      if (!isCustomKitMode) return;
      const quantity = getMainQuantity();
      const extraPriceCents = (getCustomKitPartsTotalCents() + Math.max(0, Number((_b = (_a = window.MudifyFrontShockAssembly) == null ? void 0 : _a.getSelectedTotalCents) == null ? void 0 : _b.call(_a)) || 0)) * quantity;
      const currentTotal = activeMainPriceCents * quantity + extraPriceCents;
      const hasDiscount = activeMainComparePriceCents > activeMainPriceCents;
      const financing = purchaseRoot.querySelector("#affirm-static");
      if (financing && Number(financing.dataset.amount) !== currentTotal) {
        purchaseRoot.querySelectorAll("#affirm-static, #affirm-dynamic").forEach((node) => {
          node.dataset.amount = String(currentTotal);
        });
        document.dispatchEvent(new CustomEvent("custom-kit:price-change", {
          detail: { price: currentTotal }
        }));
      }
      setAvailabilityText(((_c = purchaseRoot.querySelector(".ot-estimated-shipping")) == null ? void 0 : _c.innerText) || "");
      setCurrentPriceText(currentPriceEls, formatMoney(currentTotal));
      if (hasDiscount) {
        const compareTotal = activeMainComparePriceCents * quantity + extraPriceCents;
        setText(comparePriceEls, formatMoney(compareTotal));
        setText(savingsPriceEls, `(SAVE ${formatMoney(compareTotal - currentTotal)})`);
      } else {
        setText(comparePriceEls, "");
        setText(savingsPriceEls, "");
      }
      setVisibility(comparePriceEls, !hasDiscount);
      setVisibility(savingsPriceEls, !hasDiscount);
      if (!isAddingCustomKit) {
        const hasSelection = hasCustomKitSelection();
        purchaseButtons.forEach((button) => {
          button.disabled = !activeMainAvailable || !hasSelection;
          button.textContent = !activeMainAvailable ? "SOLD OUT" : hasSelection ? (btn == null ? void 0 : btn.dataset.originalText) || "ADD TO CART" : "SELECT AN OPTION";
        });
      }
    };
    const syncStickyVariantState = ({ id, available, formattedPrice, price } = {}) => {
      var _a, _b, _c;
      if (id && variantIdInput) {
        variantIdInput.value = id;
        variantIdInput.setAttribute("value", id);
      }
      updateProductImage(id);
      const priceData = id ? (_a = window.VARIANT_PRICE_MAP) == null ? void 0 : _a[id] : null;
      const numericPrice = Number.isFinite(Number(price)) ? Number(price) : (priceData == null ? void 0 : priceData.price) != null ? Number(priceData.price) : activeMainPriceCents;
      activeMainPriceCents = Math.max(0, Number(numericPrice) || 0);
      const currentPrice = numericPrice != null ? formatMoney(numericPrice) : typeof formattedPrice === "string" ? formattedPrice.trim() : "";
      const compareAt = (priceData == null ? void 0 : priceData.compare_at) ?? activeMainComparePriceCents;
      activeMainComparePriceCents = Math.max(0, Number(compareAt) || 0);
      const basePrice = (priceData == null ? void 0 : priceData.price) ?? price;
      const hasDiscount = compareAt && basePrice != null && compareAt > basePrice;
      if (currentPrice) {
        setCurrentPriceText(currentPriceEls, currentPrice);
      }
      if (hasDiscount) {
        setText(comparePriceEls, formatMoney(compareAt));
        setText(savingsPriceEls, `(SAVE ${formatMoney(compareAt - basePrice)})`);
      } else {
        setText(comparePriceEls, "");
        setText(savingsPriceEls, "");
      }
      setVisibility(comparePriceEls, !hasDiscount);
      setVisibility(savingsPriceEls, !hasDiscount);
      if (typeof available === "boolean") {
        activeMainAvailable = available;
        if (!isCustomKitMode) {
          const synctrackerText = (_c = (_b = document.querySelector(".ot-estimated-shipping")) == null ? void 0 : _b.innerText) == null ? void 0 : _c.trim();
          setAvailabilityText(synctrackerText || "");
        }
        if (btn && (!isCustomKitMode || !isAddingCustomKit)) {
          btn.disabled = !available;
          if (!btn.dataset.originalText) {
            btn.dataset.originalText = btn.textContent.trim();
          }
          btn.textContent = available ? btn.dataset.originalText || "ADD TO CART" : "SOLD OUT";
        }
      }
      syncCustomKitStickyState();
    };
    const setVisible = (visible) => {
      bar.classList.toggle("translate-y-full", !visible);
      bar.classList.toggle("opacity-0", !visible);
      bar.classList.toggle("pointer-events-none", !visible);
    };
    const syncViewportState = () => {
      if (inlineAtc) {
        setVisible(inlineAtc.getBoundingClientRect().bottom <= 0);
        return;
      }
      setVisible(window.scrollY > 0);
    };
    customKitAtc == null ? void 0 : customKitAtc.addEventListener("click", () => {
      if (!(btn == null ? void 0 : btn.disabled)) form == null ? void 0 : form.requestSubmit();
    }, { signal });
    if (form && btn) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (isCustomKitMode && (isAddingCustomKit || !activeMainAvailable)) return;
        const id = getActiveVariantId();
        const qty = getMainQuantity();
        if (!id) return;
        const customKitConfigurator = getCustomKitConfigurator();
        if (isCustomKitMode && (!customKitConfigurator || typeof customKitConfigurator.validate !== "function" || !customKitConfigurator.validate())) {
          customKitConfigurator == null ? void 0 : customKitConfigurator.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Adding...";
        if (isCustomKitMode) {
          isAddingCustomKit = true;
          purchaseButtons.forEach((button) => {
            button.disabled = true;
            button.textContent = "Adding...";
          });
        }
        try {
          if (!isCustomKitMode) await syncLiftKitInstallationQuote();
          const mainForm = getMainProductForm();
          const mainAtcButton = getMainAtcButton();
          if (variantIdInput) {
            variantIdInput.value = String(id);
            variantIdInput.setAttribute("value", String(id));
          }
          if (mainForm && !isCustomKitMode) {
            const mainVariantInput = mainForm.querySelector('input[name="id"]');
            if (mainVariantInput) {
              mainVariantInput.value = String(id);
              mainVariantInput.setAttribute("value", String(id));
            }
            const mainQuantityField = mainForm.querySelector('[name="quantity"]');
            if (mainQuantityField) {
              mainQuantityField.value = String(qty);
              mainQuantityField.dispatchEvent(new Event("input", { bubbles: true }));
              mainQuantityField.dispatchEvent(new Event("change", { bubbles: true }));
            }
            mainForm.dispatchEvent(new Event("change", { bubbles: true }));
            if (typeof mainForm.requestSubmit === "function") {
              mainForm.requestSubmit(mainAtcButton || void 0);
            } else if (mainAtcButton) {
              mainAtcButton.click();
            } else {
              throw new Error("Main add to cart button not found.");
            }
          } else {
            const selectedUcaItems = isCustomKitMode ? [] : getSelectedUcaItems(qty);
            const selectedTireItems = isCustomKitMode ? [] : getSelectedTireItems(qty);
            const selectedFrontShockAssemblyItems = getSelectedFrontShockAssemblyItems(qty);
            const addonItems = isCustomKitMode ? [] : getSelectedAddonItems(qty, Number(id));
            const customKitItems = isCustomKitMode ? getSelectedCustomKitItems(qty) : [];
            const extraItems = [
              ...addonItems,
              ...selectedTireItems,
              ...selectedUcaItems,
              ...selectedFrontShockAssemblyItems,
              ...customKitItems
            ];
            const mainItem = applyAddonSignatureToMainItem(buildMainCartItem(id, qty), {
              ucaItems: selectedUcaItems,
              tireItems: selectedTireItems,
              addonItems,
              frontShockAssemblyItems: selectedFrontShockAssemblyItems,
              customKitItems
            });
            const json = await addMainAndExtraItems(mainItem, extraItems);
            if (cart) {
              if (json == null ? void 0 : json.sections) {
                cart.renderContents(json);
              } else if (typeof cart.refreshCartDrawer === "function") {
                await cart.refreshCartDrawer({ open: true });
              }
            } else {
              window.location.href = "/cart";
              return;
            }
          }
          btn.textContent = "Added!";
          if (isCustomKitMode) setText(purchaseButtons, "Added!");
          setTimeout(() => {
            if (isCustomKitMode) {
              isAddingCustomKit = false;
              syncCustomKitStickyState();
            } else {
              btn.textContent = original;
              btn.disabled = false;
            }
          }, 2e3);
        } catch (error) {
          console.error(error);
          btn.textContent = "Error - try again";
          btn.disabled = false;
          if (isCustomKitMode) {
            isAddingCustomKit = false;
            syncCustomKitStickyState();
            setText(purchaseButtons, "Error - try again");
          }
        }
      }, { signal });
    }
    document.addEventListener("variant:change", (e) => {
      syncStickyVariantState(e.detail || {});
    }, { signal });
    document.addEventListener("mudify:pdp-state:change", (event) => {
      var _a, _b, _c;
      const state = (_a = event.detail) == null ? void 0 : _a.state;
      if (!(state == null ? void 0 : state.product) || !state.selectedVariant) return;
      const defaultMedia = (_b = state.product.media) == null ? void 0 : _b.find((media) => media.media_type === "image");
      variantImageMap = {
        default: defaultMedia ? { src: ((_c = defaultMedia.preview_image) == null ? void 0 : _c.src) || defaultMedia.src, alt: defaultMedia.alt || state.product.title } : null,
        ...Object.fromEntries(
          state.product.variants.map((variant) => [
            String(variant.id),
            variant.featured_image ? {
              src: variant.featured_image.src,
              alt: variant.featured_image.alt || `${state.product.title} - ${variant.title}`
            } : null
          ])
        )
      };
      activeMainPriceCents = Number(state.selectedVariant.price) || 0;
      activeMainComparePriceCents = Number(state.selectedVariant.compare_at_price) || 0;
      activeMainAvailable = Boolean(state.selectedVariant.available);
      bar.dataset.lkBasePrice = String(activeMainPriceCents);
      bar.dataset.lkBaseComparePrice = String(activeMainComparePriceCents);
      syncStickyVariantState({
        id: state.selectedVariant.id,
        available: activeMainAvailable,
        price: activeMainPriceCents,
        formattedPrice: formatMoney(activeMainPriceCents)
      });
    }, { signal });
    document.addEventListener("price:change", (e) => {
      const detail = e.detail || {};
      const formattedPrice = detail.text || "";
      const cents = Number(detail.cents);
      if (!formattedPrice && !Number.isFinite(cents)) return;
      syncStickyVariantState({
        id: variantIdInput == null ? void 0 : variantIdInput.value,
        available: !(btn == null ? void 0 : btn.disabled),
        formattedPrice: formattedPrice || formatMoney(cents),
        price: Number.isFinite(cents) ? cents : void 0
      });
    }, { signal });
    document.addEventListener("custom-kit:change", syncCustomKitStickyState, { signal });
    document.addEventListener("front-shock-assembly:addon-change", syncCustomKitStickyState, { signal });
    if (window.__lastVariantChange) {
      syncStickyVariantState(window.__lastVariantChange);
    } else {
      syncStickyVariantState({
        id: variantIdInput == null ? void 0 : variantIdInput.value,
        available: !(btn == null ? void 0 : btn.disabled)
      });
    }
    let ticking = false;
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          syncViewportState();
          ticking = false;
        });
      },
      { passive: true, signal }
    );
    window.addEventListener("resize", syncViewportState, { signal });
    syncViewportState();
    const synctrackerDiv = document.querySelector(".ot-estimated-shipping");
    if (synctrackerDiv) {
      activeAvailabilityObserver = new MutationObserver(() => {
        var _a;
        const text = (_a = synctrackerDiv.innerText) == null ? void 0 : _a.trim();
        setAvailabilityText(text || "");
      });
      activeAvailabilityObserver.observe(synctrackerDiv, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }
};
initLiftKitStickyAtc();
document.addEventListener("mudify:linked-pdp:swapped", (event) => {
  var _a, _b;
  if (((_a = event.detail) == null ? void 0 : _a.mode) === "hydration") return;
  initLiftKitStickyAtc(((_b = event.detail) == null ? void 0 : _b.root) || document);
});
